import { useQuery } from '@tanstack/react-query';
import { getSiteFiles } from '../api/filesApi';

export const siteFilesKeys = {
  all: ['site-files'] as const,
  list: (siteId: number) => [...siteFilesKeys.all, siteId] as const,
};

export function useSiteFiles(siteId: number) {
  return useQuery({
    queryKey: siteFilesKeys.list(siteId),
    queryFn: () => getSiteFiles(siteId),
  });
}
